import { observable, runInAction } from "mobx"

import { getLogger } from "@/lib/logging.ts"
import { Model } from "@/lib/Model.ts"

import type { TD_MemberProfile, TD_MemberProfile_Minimal } from "@/lib/client/generated/TypeDefinitions.ts"
import type { SyntheticEvent } from "react"


const log = getLogger("AvatarModel")

export class AvatarModel extends Model {
  readonly isPictureMissing = observable.box(false)

  constructor(readonly profile: TD_MemberProfile_Minimal | TD_MemberProfile) {
    super("AvatarModel")
  }

  readonly onImageError = (event: SyntheticEvent<HTMLImageElement, Event>) => {
    runInAction(() => this.isPictureMissing.set(true))
    log.error("Error loading avatar picture:", event)
  }

  get hasAvatarPicture(): boolean {
    return this.profile.avatar != null && this.profile.avatar != "" && !this.isPictureMissing.get()
  }
}